import { status } from '../../helpers'

const getTeamStoreDefaultState = () => {
  return {
    currentMembersList: [],
    loadMembers: status.INITIALIZED,
    loadInvitations: status.INITIALIZED,
    team: {
      id: null,
      name: null,
      preferencesBlob: null,
      teamModuleNames: []
    },
    sendingInvitations: false,
    errors: [],
    usersToRemove: [],
    individualInvitation: {
      id: null,
      email: null,
      token: null,
      succeed: false,
      state: null,
      userName: '',
      userLastName: '',
      password: null,
      reTypePassword: null
    },
    currentInvitationsList: [],
    teamInventoryData: {
      datasets: [
        {
          backgroundColor: '#eee',
          data: []
        }
      ]
    },
    shippingOptions: ['Return to sender', 'Treat as abandoned'],
    totalCount: 0,
    invitationPageCount: 0
  }
}

export default getTeamStoreDefaultState
